'use strict';

var react = require('react');
var hooks_useCallbackRef = require('../hooks/useCallbackRef.js');

function useEventListener(type, handler, element = document) {
    const savedCallbackRef = hooks_useCallbackRef.useCallbackRef(handler);
    react.useEffect(() => {
        function eventListener(event) {
            return savedCallbackRef.current(event);
        }
        if (element != null) {
            element.addEventListener(type, eventListener);
        }
        return () => {
            if (element != null) {
                element.removeEventListener(type, eventListener);
            }
        };
    }, [type, element]); // eslint-disable-line react-hooks/exhaustive-deps
}

exports.useEventListener = useEventListener;
//# sourceMappingURL=useEventListener-DSwo06ND.js.map
